export enum ConnectionType {
  OPCUA = 'OPCUA',
  LAFON = 'LAFON',
  GIR = 'GIR'
}
